/**
 * Don't use this component as icon, use TagSvgIcon component instead. Example: <TAGSvgIcon icon="someone_else" size=32 />
 */
const SomeoneElse = () => (
  <>
    <g clipPath="url(#clip0_9_564)">
      <path
        d="M21.0066 16.1903C24.3006 16.1903 26.971 13.5199 26.971 10.2258C26.971 6.93173 24.3006 4.26135 21.0066 4.26135C17.7125 4.26135 15.0421 6.93173 15.0421 10.2258C15.0421 13.5199 17.7125 16.1903 21.0066 16.1903Z"
        fill="white"
      />
      <path
        d="M21.0065 16.6741C17.4516 16.6741 14.5483 13.7808 14.5483 10.2159C14.5483 6.6511 17.4417 3.75775 21.0065 3.75775C24.5714 3.75775 27.4647 6.6511 27.4647 10.2159C27.4647 13.7808 24.5615 16.6741 21.0065 16.6741ZM21.0065 4.75512C17.9947 4.75512 15.5358 7.2041 15.5358 10.2258C15.5358 13.2475 17.9848 15.6965 21.0065 15.6965C24.0283 15.6965 26.4772 13.2475 26.4772 10.2258C26.4772 7.2041 24.0184 4.75512 21.0065 4.75512Z"
        fill="#002D55"
      />
      <path
        d="M29.5089 27.5267C30.1014 27.5267 30.5655 27.0033 30.4964 26.4207C29.9434 21.661 25.9046 17.9678 20.9967 17.9678C16.0889 17.9678 12.0501 21.661 11.4971 26.4207C11.4279 27.0132 11.8921 27.5267 12.4846 27.5267H29.5089V27.5267Z"
        fill="#B9DEFA"
      />
      <path
        d="M29.5089 28.0204H12.4944C12.0698 28.0204 11.6649 27.8427 11.3884 27.5267C11.1119 27.2107 10.9737 26.786 11.023 26.3614C11.6057 21.2956 15.9013 17.474 21.0066 17.474C26.1119 17.474 30.4075 21.2956 30.9901 26.3614C31.0395 26.786 30.9013 27.2008 30.6248 27.5267C30.3483 27.8525 29.9335 28.0204 29.5089 28.0204ZM21.0066 18.4615C16.4049 18.4615 12.524 21.9078 12.0007 26.4799C11.9809 26.6182 12.0303 26.7663 12.129 26.8749C12.2278 26.9835 12.3562 27.0428 12.5043 27.0428H29.5188C29.6669 27.0428 29.7953 26.9835 29.894 26.8749C29.9928 26.7663 30.0323 26.628 30.0224 26.4799C29.4793 21.9078 25.6083 18.4615 21.0066 18.4615Z"
        fill="#002D55"
      />
      <path
        d="M12.692 16.5162C16.5642 16.5162 19.7032 13.3771 19.7032 9.50497C19.7032 5.63279 16.5642 2.49377 12.692 2.49377C8.8198 2.49377 5.68079 5.63279 5.68079 9.50497C5.68079 13.3771 8.8198 16.5162 12.692 16.5162Z"
        fill="white"
      />
      <path
        d="M12.6919 17.0099C8.55436 17.0099 5.18701 13.6425 5.18701 9.50494C5.18701 5.36735 8.55436 2 12.6919 2C16.8295 2 20.1969 5.36735 20.1969 9.50494C20.1969 13.6425 16.8295 17.0099 12.6919 17.0099ZM12.6919 2.98749C9.09748 2.98749 6.1745 5.91047 6.1745 9.50494C6.1745 13.0994 9.09748 16.0224 12.6919 16.0224C16.2864 16.0224 19.2094 13.0994 19.2094 9.50494C19.2094 5.91047 16.2864 2.98749 12.6919 2.98749Z"
        fill="#002D55"
      />
      <path
        d="M22.9026 29.867C23.4852 29.867 23.9493 29.3634 23.8901 28.7808C23.3469 23.083 18.5379 18.6195 12.6919 18.6195C6.84596 18.6195 2.04675 23.083 1.49375 28.7808C1.4345 29.3634 1.89863 29.867 2.48125 29.867H22.9026V29.867Z"
        fill="white"
      />
      <path
        d="M22.9026 30.3608H2.49116C2.07641 30.3608 1.67154 30.183 1.39504 29.8769C1.10867 29.5708 0.970421 29.1461 1.00992 28.7314C1.59254 22.6879 6.61887 18.1257 12.6919 18.1257C18.7749 18.1257 23.8012 22.6879 24.374 28.7314C24.4135 29.1461 24.2752 29.5609 23.9889 29.8769C23.7222 30.183 23.3174 30.3608 22.9026 30.3608ZM12.6919 19.1132C7.1225 19.1132 2.52078 23.2903 1.98754 28.8203C1.97766 28.9585 2.01716 29.0968 2.11591 29.2054C2.21466 29.314 2.34303 29.3733 2.48128 29.3733H22.8927C23.031 29.3733 23.1692 29.314 23.2581 29.2054C23.3569 29.0968 23.3964 28.9585 23.3865 28.8203C22.8631 23.2903 18.2614 19.1132 12.6919 19.1132Z"
        fill="#002D55"
      />
    </g>
    <defs>
      <clipPath id="clip0_9_564">
        <rect width="30" height="28.3608" fill="white" transform="translate(1 2)" />
      </clipPath>
    </defs>
  </>
)

export default SomeoneElse
